import { useState } from "react";
import Textarea from "../../../componentes/input/textarea";
import Button from "../../../componentes/button/button";

export default function ComentarioForm({ onEnviar }) {
    const [texto, setTexto] = useState("");
    const [enviando, setEnviando] = useState(false);

    function enviar() {
        if (!texto.trim() || enviando) return;
        setEnviando(true);
        onEnviar(texto.trim())
            .then(() => setTexto(""))
            .finally(() => setEnviando(false));
    }

    return (
        <div className="flex flex-col gap-2">
            <Textarea
                id="comentario"
                placeholder="Escreva um comentário..."
                value={texto}
                onChange={e => setTexto(e.target.value)}
                rows={2}
            />
            <div className="flex justify-end">
                <Button
                    variant="blue"
                    label="Adicionar Comentário"
                    iconLeft="fa fa-plus"
                    loading={enviando}
                    disabled={!texto.trim()}
                    onClick={enviar}
                />
            </div>
        </div>
    );
}
